export const FETCH_DOCTORS_WITH_EVERY_QUERY_REQUEST = "FETCH_DOCTORS_WITH_EVERY_QUERY_REQUEST";
export const _SUCCESS = "_SUCCESS";
export const _FAILURE = "_FAILURE";
